export default __webpack_public_path__ + "55540f1e1e4da07e61560f87e48f91dc.jpg";